import { Pompe } from '../../domain/pompe';
import { mapper } from '../../tools/mapping/mapper';
import { PompeEntity } from '../entity';
import type { AppDB } from '../db';

export class PompeRepository {
    constructor(private readonly database: AppDB) {}


    async getPompeEntityById(id: number) {
        return await this.database.pompes.where('Id').equals(id).first(async pe => {
            return pe;
        });
    }

    async attachPompe(pompe: Pompe, cassetteId: number) {
        let pompeId: number;
        const pe = mapper.map(pompe, Pompe, PompeEntity);
        pompeId = await this.database.pompes.add(pe);
        await this.database.cassettes.update(cassetteId, {
            PompeId: pompeId
        });
    }
}
